<div
  #trigger="cdkOverlayOrigin"
  cdkOverlayOrigin
  class="group flex h-10 px-2.5 gap-x-2.5 border border-solid {{
    isDropdownOpened ? 'border-navy-90' : 'border-navy-60'
  }} rounded-md hover:border-navy-90 items-center cursor-pointer"
  (click)="toggleDropdown($event)"
>
  <svg-icon class="w-6 h-6" [src]="selectedOptionIcon"></svg-icon>
  <svg-icon
    class="{{ isDropdownOpened ? 'text-navy-90' : 'text-navy-60' }} group-hover:text-navy-90"
    [src]="'arrow-down'"
  ></svg-icon>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isDropdownOpened"
  [cdkConnectedOverlayPanelClass]="overlayPanelClass"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayPositions]="dropdownPosition"
  (backdropClick)="close()"
>
  <app-dropdown-options-backdrop
    #openableElement
    data-test-id="color-picker-dropdown"
    class="shadow-sm border border-solid border-navy-90 p-0"
  >
    <div class="flex flex-wrap gap-3 py-5 px-6 max-w-93 box-border">
      @for (item of displayedData; track $index) {
        <div
          class="group relative cursor-pointer w-6 h-6"
          [attr.data-test-id]="'color-' + getItemId(item)"
          (click)="selectItem(item)"
        >
          <svg-icon class="w-6 h-6" [src]="optionIconSelector(item)"></svg-icon>
          <span
            class="w-8 h-8 border border-solid border-navy-70 absolute top-0 left-0 transform -translate-x-1 -translate-y-1 rounded group-hover:block"
            [class.block]="isSelected(item)"
            [class.hidden]="!isSelected(item)"
          ></span>
        </div>
      }
    </div>
  </app-dropdown-options-backdrop>
</ng-template>
